import React, { useState, useEffect, useRef } from "react";
import { X, Search, User } from "lucide-react";

export default function WhatsForwardDrawer({ chats, onForward, onClose }) {
  const [search, setSearch] = useState("");
  // Mostrar los últimos 50 chats
  const filtered = chats
    .filter((c) => !search || (c.name || c.chat_jid).toLowerCase().includes(search.toLowerCase()))
    .slice(0, 50);

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div
      style={{
        position: "absolute",
        bottom: "100%",
        left: 0,
        right: 0,
        backgroundColor: "white",
        borderTop: "1px solid #e2e8f0",
        borderTopLeftRadius: "var(--radius-xl)",
        borderTopRightRadius: "var(--radius-xl)",
        boxShadow: "0 -4px 15px rgba(0,0,0,0.1)",
        zIndex: 20,
        display: "flex",
        flexDirection: "column",
        maxHeight: "350px",
      }}
    >
      <div style={{ padding: "12px 16px", borderBottom: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#f0f2f5", borderTopLeftRadius: "var(--radius-xl)", borderTopRightRadius: "var(--radius-xl)" }}>
        <h3 style={{ margin: 0, fontSize: "15px", color: "#111b21", fontWeight: "600" }}>Reenviar mensaje</h3>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#54656f", padding: "4px" }}>
          <X size={18} />
        </button>
      </div>
      <div style={{ padding: "12px", borderBottom: "1px solid #eee" }}>
        <div style={{ position: "relative" }}>
          <Search size={16} style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#8696a0" }} />
          <input
            ref={inputRef}
            type="text"
            placeholder="Buscar contacto..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && filtered.length > 0) {
                onForward(filtered[0].chat_jid);
              } else if (e.key === "Escape") {
                onClose();
              }
            }}
            style={{ width: "100%", padding: "8px 10px 8px 36px", borderRadius: "var(--radius-md)", border: "1px solid #ddd", boxSizing: "border-box", outline: "none", fontSize: "14px" }}
          />
        </div>
      </div>
      <div style={{ overflowY: "auto", flex: 1, padding: "0 8px" }}>
        {filtered.map((chat) => (
          <div
            key={chat.chat_jid}
            onClick={() => onForward(chat.chat_jid)}
            style={{ padding: "10px", borderBottom: "1px solid #f0f2f5", display: "flex", alignItems: "center", gap: "12px", cursor: "pointer", transition: "background-color 0.1s" }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f8fafc"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "transparent"}
          >
            <div style={{ width: "36px", height: "36px", borderRadius: "50%", backgroundColor: "#e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
              {chat.avatar_url
                ? <img src={chat.avatar_url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                : <User size={18} color="#64748b" />}
            </div>
            <div style={{ flex: 1, overflow: "hidden" }}>
              <div style={{ fontWeight: "500", color: "#111b21", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", fontSize: "14px" }}>
                {chat.name || "+" + chat.chat_jid.split("@")[0]}
              </div>
            </div>
            <div style={{ color: "#00a884", fontSize: "12px", fontWeight: "600" }}>Enviar</div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div style={{ padding: "20px", textAlign: "center", color: "#8696a0", fontSize: "14px" }}>
            No se encontraron contactos.
          </div>
        )}
      </div>
    </div>
  );
}
